export default {
  landing_not_found: 'Ошибка! Такого лендинга не сущуствует',
  item_not_found: 'Ошибка! Сначала нужно сохранить лендинг',
  module_not_found: 'Ошибка! Включите модуль Яндекс Деньги',
  yam_error:
    'Ошибка! Неверно введены данные в на странице настроек Яндекс Деньги.'
};
